var map = {
	"./1722238712046-w1.jpg": 6275,
	"./1722238779037-w2.jpg": 3993,
	"./1722238805724-w3.jpg": 6587,
	"./1722238860651-w5.jpg": 861,
	"./1722238881835-w6.jpg": 9513,
	"./1722238914891-w7.webp": 6583,
	"./1722238938548-w8.jpg": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;